import React, { useState, useEffect } from 'react';
import './Menu.css';
import { IoHomeOutline, IoStorefrontOutline, IoGridOutline, IoCartOutline, IoPricetagsOutline } from "react-icons/io5";
import { HiOutlinePaintBrush, HiOutlineUsers, HiOutlineTruck } from "react-icons/hi2";
import { BsCartPlus } from "react-icons/bs";
import { FiMenu, FiDollarSign, FiRefreshCw, FiX } from 'react-icons/fi';
import { MdPointOfSale } from 'react-icons/md';
import { RiCouponLine } from 'react-icons/ri';
import { PiClipboardText } from 'react-icons/pi';
import MenuItem from './MenuItem';
import MenuSubmenu from './MenuSubmenu';
import MenuRechargeCartaButton from './MenuRechargeCartaButton';
import MenuAccountActions from './MenuAccountActions';
import {useConfig} from "../../context/ConfigContext";
import {GoGear, GoPerson} from "react-icons/go";
import { TbListNumbers, TbBarcode, TbPackage, TbArrowsExchange, TbReceipt } from "react-icons/tb";
import {getUserRoleFromToken} from "../../auth/authUtils";
import NotificationBell from "../notifications/NotificationBell";
import { isClientModuleActive, isProviderModuleActive } from '../../utils/moduleUtils';
import MenuPlanBadge from './MenuPlanBadge';

export default function Menu() {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const userRole = getUserRoleFromToken();

    // Función para verificar el tamaño de la pantalla y definir si es móvil o no
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); // Define tamaño de pantalla móvil como <= 768px
    };

    useEffect(() => {
        handleResize(); // Verifica al montar el componente
        window.addEventListener('resize', handleResize); // Agrega evento de escucha para redimensionar

        return () => {
            window.removeEventListener('resize', handleResize); // Limpia evento al desmontar componente
        };
    }, []);

    useEffect(() => {
        const sidebarWidth = isMobile ? '0px' : (isOpen ? '250px' : '52px');
        document.documentElement.style.setProperty('--app-sidebar-width', sidebarWidth);
    }, [isOpen, isMobile]);

    // MODULOS DE CONFIGURACIONES DE NEGOCIO
    const { features } = useConfig();
    const stockFeature = features.find(feature => feature.name === 'STOCK');
    const reportsFeature = features.find(feature => feature.name === 'REPORTES');
    const priceListFeature = features.find(feature => feature.name === 'LISTAS_PRECIOS');

    // Verificar si tiene activa alguna de las features
    const clientFeature = isClientModuleActive(features);
    const showClientMenu = clientFeature && userRole === 'ADMIN';
    const showClientAccountsMenu = clientFeature && userRole === 'ADMIN';

    const showProviderMenu = isProviderModuleActive(features) && userRole === 'ADMIN';
    const showProviderAccountsMenu = isProviderModuleActive(features) && userRole === 'ADMIN';
    const showProviderOrders = isProviderModuleActive(features);

    const showClientSection = showClientMenu || showClientAccountsMenu;
    const showProviderSection = showProviderMenu || showProviderAccountsMenu || showProviderOrders;

    const clientSubmenuItems = [
        showClientMenu && { path: '/client', text: 'Clientes' },
        showClientAccountsMenu && { path: '/client-accounts', text: 'Cuentas corrientes' },
    ].filter(Boolean);

    const providerSubmenuItems = [
        showProviderMenu && { path: '/providers', text: 'Proveedores' },
        showProviderOrders && { path: '/pedidos-proveedores', text: 'Pedidos a Proveedores' },
        showProviderAccountsMenu && { path: '/provider-accounts', text: 'Cuentas corrientes' },
    ].filter(Boolean);

    const configuracionesSubmenuItems = [
        { path: '/config/carta', text: 'Carta' },
        { path: '/config/sistema', text: 'Sistema' },
    ];

    // Verificar si tiene activo el módulo de PEDIDOS_V2
    const pedidosV2Feature = features.find(feature => feature.name === 'PEDIDOS CAJA' && (feature.status === true || feature.status === 1));
    const promotionsFeature = features.find(feature => feature.name === 'PROMOCIONES' && (feature.status === true || feature.status === 1));
    const priceLabelFeature = features.find(feature => feature.name === 'ETIQUETA PRECIO' && (feature.status === true || feature.status === 1));
    const cashRegisterFeature = features.find(feature => feature.name === 'REGISTRO CAJA' && (feature.status === true || feature.status === 1));
    const invoicingFeature = features.find(feature => feature.name === 'FACTURACION' && (feature.status === true || feature.status === 1));
    // Mostrar el menú de Pedidos Caja si tiene el módulo activo
    const showPedidosCaja = pedidosV2Feature;
    const showPromotions = promotionsFeature;
    const showPriceLabels = priceLabelFeature;
    const showCashRegister = cashRegisterFeature;

    const toggleSidebar = () => setIsOpen(!isOpen);
    const openSidebar = () => setIsOpen(true);
    const closeSidebar = () => setIsOpen(false);

    return (
        <>
            <NotificationBell />
            {isMobile ?
                (
                    <div className={`menu-container ${isOpen ? 'open' : ''}`}>
                        {!isOpen && (
                            <button className="menu-toggle-btn" type="button" onClick={toggleSidebar} aria-label="Abrir menu">
                                <FiMenu />
                            </button>
                        )}

                        {isOpen && <div className="menu-overlay" onClick={closeSidebar} aria-hidden="true" />}

                        <nav className={`mobile-nav ${isOpen ? 'open' : 'closed'}`} aria-hidden={!isOpen}>
                            <div className="mobile-nav-header">
                                <span className="mobile-nav-title">Menu</span>
                                <button type="button" className="mobile-nav-close" onClick={closeSidebar} aria-label="Cerrar menu">
                                    <FiX />
                                </button>
                            </div>
                            <div className="menu-nav">
                            <MenuPlanBadge isOpen={true} />
                            <MenuItem isOpen={isOpen} path={"/home"} Icon={IoHomeOutline} text={"Inicio"} onClick={closeSidebar} />
                            {userRole === 'ADMIN' &&
                                <>
                                    <MenuItem isOpen={isOpen} path={"/shop"} Icon={IoStorefrontOutline} text={"Local/ Sucursales"} onClick={closeSidebar} />
                                    <MenuItem isOpen={isOpen} path={"/users"} Icon={HiOutlineUsers} text={"Usuarios"} onClick={closeSidebar} />
                                </>}
                            <MenuItem isOpen={isOpen} path={"/categories"} Icon={IoGridOutline} text={"Categorías"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/marcas"} Icon={IoPricetagsOutline} text={"Marcas"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/misProductos"} Icon={PiClipboardText} text={"Productos"} onClick={closeSidebar} />
                            {stockFeature && stockFeature.status && <MenuItem isOpen={isOpen} path={"/stock"} Icon={TbPackage} text={"Stock"} onClick={closeSidebar}/>}
                            {showClientSection && (
                                <MenuSubmenu
                                    isOpen={isOpen}
                                    isMobile={isMobile}
                                    text="Clientes"
                                    Icon={GoPerson}
                                    items={clientSubmenuItems}
                                    onClick={closeSidebar}
                                />
                            )}
                            {showProviderSection && (
                                <MenuSubmenu
                                    isOpen={isOpen}
                                    isMobile={isMobile}
                                    text="Proveedores"
                                    Icon={HiOutlineTruck}
                                    items={providerSubmenuItems}
                                    onClick={closeSidebar}
                                />
                            )}
                            {showPromotions && (
                                <MenuItem isOpen={isOpen} path={"/promotions"} Icon={RiCouponLine} text={"Promociones"} onClick={closeSidebar} />
                            )}
                            {showPriceLabels && (
                                <MenuItem isOpen={isOpen} path={"/price-labels"} Icon={TbBarcode} text={"Etiquetas Precio"} onClick={closeSidebar} />
                            )}
                            <MenuItem isOpen={isOpen} path={"/personalizacion"} Icon={HiOutlinePaintBrush} text={"Diseño"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/pedidoMostrador"} Icon={BsCartPlus} text={"Crear pedido"} onClick={closeSidebar} />
                            {showPedidosCaja && (
                                <MenuItem isOpen={isOpen} path={"/pedidosCaja"} Icon={MdPointOfSale} text={"Pedidos Caja"} onClick={closeSidebar} />
                            )}
                            <MenuItem isOpen={isOpen} path={"/orders"} Icon={IoCartOutline} text={"Pedidos"} onClick={closeSidebar} />
                            <MenuSubmenu
                                isOpen={isOpen}
                                isMobile={isMobile}
                                text="Configuraciones"
                                Icon={GoGear}
                                items={configuracionesSubmenuItems}
                                onClick={closeSidebar}
                            />
                            {reportsFeature && reportsFeature.status && <MenuItem isOpen={isOpen} path={"/movements"} Icon={TbArrowsExchange} text={"Movimientos"} onClick={closeSidebar}/>}
                            {showCashRegister && (
                                <MenuItem isOpen={isOpen} path={"/cash-register"} Icon={TbReceipt} text={"Caja"} onClick={closeSidebar} />
                            )}
                            {invoicingFeature && (
                                <MenuItem isOpen={isOpen} path={"/points-of-sale"} Icon={FiDollarSign} text={"Puntos de Venta"} onClick={closeSidebar} />
                            )}
                            <MenuItem 
                                isOpen={isOpen} 
                                path={"/price-lists"} 
                                Icon={TbListNumbers} 
                                text={"Listas de Precios"} 
                                onClick={closeSidebar}
                            />
                            <MenuRechargeCartaButton isOpen={isOpen}/>
                            <MenuAccountActions isOpen={isOpen} isMobile={true}/>
                            </div>
                        </nav>

                    </div>
                )
                :
                (
                    <div
                        className={`zindex sidebar ${isOpen ? 'open' : 'closed'}`}
                        onMouseEnter={openSidebar}
                        onMouseLeave={closeSidebar}
                    >
                            <nav className="menu-nav">
                            <MenuPlanBadge isOpen={isOpen} />
                            <MenuItem isOpen={isOpen} path={"/home"} Icon={IoHomeOutline} text={"Inicio"} onClick={closeSidebar}/>
                            {userRole === 'ADMIN' &&
                                <>
                                    <MenuItem isOpen={isOpen} path={"/shop"} Icon={IoStorefrontOutline} text={"Local/ Sucursales"} onClick={closeSidebar}/>
                                    <MenuItem isOpen={isOpen} path={"/users"} Icon={HiOutlineUsers} text={"Usuarios"} onClick={closeSidebar}/>
                                </>}
                            <MenuItem isOpen={isOpen} path={"/categories"} Icon={IoGridOutline} text={"Categorías"} onClick={closeSidebar}/>
                            <MenuItem isOpen={isOpen} path={"/marcas"} Icon={IoPricetagsOutline} text={"Marcas"} onClick={closeSidebar}/>
                            <MenuItem isOpen={isOpen} path={"/misProductos"} Icon={PiClipboardText} text={"Productos"} onClick={closeSidebar}/>
                            {stockFeature && stockFeature.status && <MenuItem isOpen={isOpen} path={"/stock"} Icon={TbPackage} text={"Stock"} onClick={closeSidebar}/>}
                            {showClientSection && (
                                <MenuSubmenu
                                    isOpen={isOpen}
                                    isMobile={isMobile}
                                    text="Clientes"
                                    Icon={GoPerson}
                                    items={clientSubmenuItems}
                                    onClick={closeSidebar}
                                />
                            )}
                            {showProviderSection && (
                                <MenuSubmenu
                                    isOpen={isOpen}
                                    isMobile={isMobile}
                                    text="Proveedores"
                                    Icon={HiOutlineTruck}
                                    items={providerSubmenuItems}
                                    onClick={closeSidebar}
                                />
                            )}
                            {showPromotions && (
                                <MenuItem isOpen={isOpen} path={"/promotions"} Icon={RiCouponLine} text={"Promociones"} onClick={closeSidebar}/>
                            )}
                            {showPriceLabels && (
                                <MenuItem isOpen={isOpen} path={"/price-labels"} Icon={TbBarcode} text={"Etiquetas Precio"} onClick={closeSidebar}/>
                            )}
                            <MenuItem isOpen={isOpen} path={"/personalizacion"} Icon={HiOutlinePaintBrush} text={"Diseño"} onClick={closeSidebar}/>
                            <MenuItem isOpen={isOpen} path={"/pedidoMostrador"} Icon={BsCartPlus} text={"Crear pedido"} onClick={closeSidebar}/>
                            {showPedidosCaja && (
                                <MenuItem isOpen={isOpen} path={"/pedidosCaja"} Icon={MdPointOfSale} text={"Pedidos Caja"} onClick={closeSidebar}/>
                            )}
                            <MenuItem isOpen={isOpen} path={"/orders"} Icon={IoCartOutline} text={"Pedidos"} onClick={closeSidebar}/>
                            <MenuSubmenu
                                isOpen={isOpen}
                                isMobile={isMobile}
                                text="Configuraciones"
                                Icon={GoGear}
                                items={configuracionesSubmenuItems}
                                onClick={closeSidebar}
                            />
                            {reportsFeature && reportsFeature.status && <MenuItem isOpen={isOpen} path={"/movements"} Icon={TbArrowsExchange} text={"Movimientos"} onClick={closeSidebar}/>}
                            {showCashRegister && (
                                <MenuItem isOpen={isOpen} path={"/cash-register"} Icon={TbReceipt} text={"Caja"} onClick={closeSidebar}/>
                            )}
                            {invoicingFeature && (
                                <MenuItem isOpen={isOpen} path={"/points-of-sale"} Icon={FiDollarSign} text={"Puntos de Venta"} onClick={closeSidebar}/>
                            )}
                            <MenuItem 
                                isOpen={isOpen} 
                                path={"/price-lists"} 
                                Icon={TbListNumbers} 
                                text={"Listas de Precios"}
                                onClick={closeSidebar}
                            />
                            <MenuRechargeCartaButton isOpen={isOpen}/>
                        </nav>

                        <MenuAccountActions isOpen={isOpen} isMobile={false}/>
                    </div>
                )
            }
        </>
    );
}
